import { DOCUMENT_ELEMENT, SELECTORS } from '@/scripts/constants';
import { isMobile } from '@/scripts/helper';
import { initProjectSlider } from './sliders'; 

import '@/scripts/normalize';

// assets
import '@/styles/main.scss';

document.addEventListener('DOMContentLoaded', () => {
  initProjectSlider();
  
  const accordionElement = document.querySelector('.js-accordion');
  if (accordionElement) {
    new Accordion('.js-accordion');  
  }
});
